import React, { useEffect, useState } from "react";
import { hqApi } from "@/hq/hqApi";
import { Card, EmptyState, Skeleton, Pagination } from "@/hq/HQPrimitives";
import ActivityTimeline from "@/hq/ActivityTimeline";

export default function HQActivity() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    setData(null);
    hqApi.get("/activity", { params: { page, page_size: 25 } })
      .then((r) => alive && setData(r.data))
      .catch(() => alive && setErr("Something went wrong loading activity."));
    return () => { alive = false; };
  }, [page]);

  return (
    <div className="space-y-4" data-testid="hq-activity-page">
      <Card className="p-6">
        <div className="text-[10px] tracking-[0.28em] uppercase font-bold text-[#FF6A00]">Timeline</div>
        <h2 className="mt-1 font-black text-lg tracking-[-0.01em]">All activity across Orange Core</h2>

        <div className="mt-6">
          {!data ? (
            <div className="space-y-3">{[0,1,2,3].map(i => <Skeleton key={i} h={44} />)}</div>
          ) : (data.items || []).length === 0 ? (
            <EmptyState title="No activity yet" hint="Events will appear here as leads, businesses and websites are created." testId="hq-activity-page-empty" />
          ) : (
            <ActivityTimeline items={data.items} />
          )}
        </div>
      </Card>

      {data && <Pagination page={data.page} total_pages={data.total_pages} onPage={setPage} testIdPrefix="hq-activity-page" />}
    </div>
  );
}
